import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { showCaseApiURL } from 'Constants/Constants';
import axios from 'axios';

const initialState = {
  listAvaiabilityUnvaible: [],
  loading: false,
  loadingTimer: false,
  fetchTimerDailyOffer: {},
};

export const fetchTimerDailyOffer = createAsyncThunk(
  'showCase/fetchTimerDailyOffer',
  async (payload, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const response = await axios.get(`${showCaseApiURL}/Showcase/DailyOffer/${payload.id}`, { headers });

    return response.data;
  }
);

const AutomateShowcaseSlice = createSlice({
  name: 'AutomateShowcaseSlice',
  initialState: initialState,
  reducers: {
    addAvaiabilityUnvaible: (state, action) => {
      state.listAvaiabilityUnvaible.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimerDailyOffer.pending, (state) => {
        state.loadingTimer = true;
      })
      .addCase(fetchTimerDailyOffer.fulfilled, (state, action) => {
        state.loadingTimer = false;

        state.fetchTimerDailyOffer = action.payload;
      })
      .addCase(fetchTimerDailyOffer.rejected, (state) => {
        state.loadingTimer = false;
      });
  },
});
export const { addAvaiabilityUnvaible } = AutomateShowcaseSlice.actions;
export default AutomateShowcaseSlice.reducer;
